app.service("AssemblyService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const AssemblyModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Assembly",
        id: "assembly",
        navigation_pointer: "assembly_id"
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            rigid: new RouteChoice({
                name: "Rigid"
            }),
            flat_pack: new RouteChoice({
                name: "Flat-Pack"
            }),
        },

        birth: function (values) {
            return new AssemblyModel(values);
        },

        applyModelVariation: applyModelVariation
    })


    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const browseID = variationIDs.browse_id;
        const solutionID = variationIDs.solution_id;
        const baseComponentID = variationIDs.base_component_id;

        let choiceOrder = [];
        if (solutionID === "kitchen_rigid_flat_pack" || baseComponentID === "solution") {
            choiceOrder = ['rigid', 'flat_pack'];
        } else if (solutionID === "kitchen_inrail") {
            choiceOrder = ['rigid'];
        } else if (solutionID === "bedroom_flat_pack") {
            choiceOrder = ['flat_pack'];
        }
        let nextModelID;
        if (["solution", "site_range"].includes(browseID)) {
            nextModelID = "component";
        } else if (baseComponentID === "stock") {
            nextModelID = "collection_product";
        } else {
            nextModelID = "individual_product";
        }

        model.choice_order = choiceOrder;
        model.next_model_id = nextModelID;
    }

}]);